import "./Industries.css";

const Industries = () => {
  return (
    <section className="industries">
      <div className="industries-container">

        <div className="industries-header">
          <span className="industries-tag">INDUSTRIES</span>
          <h2>
            Industries We <span>Serve</span>
          </h2>
        </div>

        <div className="industries-grid">

          <div className="industry-card">
            <div className="industry-icon">❤️</div>
            <h3>Healthcare</h3>
          </div>

          <div className="industry-card">
            <div className="industry-icon">🎓</div>
            <h3>Education</h3>
          </div>

          <div className="industry-card">
            <div className="industry-icon">🏦</div>
            <h3>Finance & FinTech</h3>
          </div>

          <div className="industry-card">
            <div className="industry-icon">🛒</div>
            <h3>eCommerce & Retail</h3>
          </div>

          <div className="industry-card">
            <div className="industry-icon">🎮</div>
            <h3>Gaming & Entertainment</h3>
          </div>

          <div className="industry-card">
            <div className="industry-icon">🚚</div>
            <h3>Logistics</h3>
          </div>

          <div className="industry-card">
            <div className="industry-icon">🚀</div>
            <h3>Startups & SaaS</h3>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Industries;
